export const MATCH_REFERRAL_TO_EMPLOYEE_RECORD = "MATCH_REFERRAL_TO_EMPLOYEE_RECORD";
export const MATCH_REFERRAL_TO_NEW_EMPLOYEE_RECORD = "MATCH_REFERRAL_TO_NEW_EMPLOYEE_RECORD";
export const LOAD_PARTIALLY_MATCHED_REFERRAL_DETAIL = "LOAD_PARTIALLY_MATCHED_REFERRAL_DETAIL";
export const RERUN_PARTIALLY_MATCHED_REFERRAL_DETAIL = "RERUN_PARTIALLY_MATCHED_REFERRAL_DETAIL";
